module.exports = __webpack_public_path__ + "static/media/merge.e4b5edcc.svg";